// src/main.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import './styles/globals.css';
import App from './App';

import { store } from './store/store'; // 👈 ESTE caminho
import { restoreSession } from './store/slices/authSlice';

// Hidrata o Redux antes da primeira renderização. Sem isso, um F5 ou um novo
// deploy mantém o token no navegador, mas o portal nasce sem affiliateId.
store.dispatch(restoreSession());

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
